<div class="margin-top">
    <app-home-jewels></app-home-jewels>
</div>